import React, { useState } from "react";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import Button from "../../atoms/button/button";
import ShareModal from "../../molecules/ShareModal/ShareModal";
import { RiShareForwardFill } from "@react-icons/all-files/ri/RiShareForwardFill";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

import "./headboardAticlesPage.scss";
import { Link } from "gatsby";

const HeadboardAticlesPage = (props: ReferenciaCabecera) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };
  const data = props;
  
  return (
    <div className="m-aggregator">
      <ShareModal
        open={isModalVisible}
        onClose={toggleModal}
        gtmClass={`gtm${normalizeTwoWords(
          props.tituloPrincipal
        )}Articulo${normalizeTwoWords(props.tituloPrincipal)}Compartir`}
      />
      <div className="m-aggregator__top">
        <div className="m-aggregator__top-breadcrumb">
          <Breadcrumb content={data.migaDePan} />
        </div>
        <div className="m-aggregator__top-banner">
          <div className="m-aggregator__top-image">
            <img src={data.imagenHeader.file.url} alt="" />
          </div>
          <div className="m-aggregator__top-content">
            <h1
              className="m-aggregator__top-title"
              dangerouslySetInnerHTML={{ __html: data.tituloPrincipal }}
            ></h1>
            <span className="m-aggregator__top-edition-number">
              {data.tituloSpan}
            </span>
            <Link to={data.redireccionBoton} className="m-aggregator__top-edition-link" target="_blank" rel="noreferrer">
              <Button
                type="button"
                classname="main-button"
                text={data.tituloBoton}
                isDisabled={false}
              />
            </Link>
            <div className="m-aggregator__top-share">
              <div className="o-headboard-two__container__content__btns">
                <Button
                  onClickAction={toggleModal}
                  text=" compartir"
                  isDisabled={false}
                  classname="o-headboard-two__container__content__btns__btn"
                  IconAlt={<RiShareForwardFill />}
                  type="button"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeadboardAticlesPage;
